<div class="mb-3"><strong>Repair Work Items</strong></div>
    <hr class="my-0">
    <table class="table table-sm table-no-bottom-border lh-md mb-0">
    <tbody>
    <tr *ngFor="let repair of repairsDto; let i = index">
        <td class="text-end align-top">{{ i + 1 }}.</td>
        <td class="w-50 align-top">{{repair.partLabel ?? 'Part Not Listed'}}</td>
        <td class="w-50 text-end align-top">P{{ repair.partPrice ? (repair.partPrice | currency) : (0|currency) }} x Q{{repair.partQuantity ?? 1}} + L{{ repair.labourPrice ? (repair.labourPrice|currency) : (0|currency) }} =
            <strong>{{ repair.total|currency }}</strong>
        </td>
    </tr>
    </tbody>
</table>
<hr class="my-0">
